import type { ChangeFlightPage } from '@/app/common/starTrack/events/utils/starTrack.types.ts';

export const CHANGE_FLIGHT_PAGE_SHOWN = 'CHANGE_FLIGHT_PAGE_SHOWN';
export const CHANGE_FLIGHT_PAGE_SHOWN_VERSION = '1.2';

export type ChangeFlightPageShownPayload = {
  searchId: string;
  productDetailKey: string;
  page: ChangeFlightPage;
};

export type ChangeFlightPageShownParams = {
  searchId: string;
  productDetailKey: string;
  page: ChangeFlightPage;
};

export const createChangeFlightPageShownPayload = (
  params: ChangeFlightPageShownParams
): ChangeFlightPageShownPayload => {
  const { searchId, productDetailKey, page } = params;

  const payload = {
    searchId,
    productDetailKey,
    page,
  };

  return payload;
};
